<template>

  <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Eko aplikacija</h1>
        <p>Evidenca pridelovalcev in predelovalcev ekoloških in integriranih kmetijskih pridelkov oziroma živil</p>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <p>
       Dobrodošli na spletnih straneh aplikacije za vodenje evidence pridelovalcev in predelovalcev ekoloških in integriranih kmetijskih pridelkov oziroma živil!
      </p>
      <p>
        Na tej spletni strani lahko potrošniki preverijo verodostojnost certifikata, ki so jih izdale organizacije za kontrolo in certificiranje, za posamezne ekološke proizvode in za proizvode iz obdobja preusmeritve.
      </p>
      <p>
        V iskalnik vnesite številko certifikata ali priimek pridelovalca ali naziv predelovalca. Nato kliknete na ikono iskalne lupe ali pritisnete tipko "Enter". Ko kliknete na »Poglej« pri iskanem ekološkem pridelovalcu ali predelovalcu se vam odprejo podatki o ekološkem pridelovalcu oziroma predelovalcu. Za ogled certifikata kliknite na »Prenesi«.
      </p>

      <form @submit.prevent="handleSubmit" class="k-form">
          <!-- <span>Številka certifikata, priimek pridelovalca ali naziv predelovalca</span> -->
               <div class="display-flex">
               <input type="text" v-model="isci" placeholder="Številka certifikata, priimek pridelovalca ali naziv predelovalca" name="isci" id="isci" class="k-textbox k-textboxlong" v-on:keyup.enter="isciCertifikat" />
                 <span class="input-icon-search" @click="isciCertifikat"><font-awesome-icon  icon="search"/></span>
            </div>
        
     
    </form>
    <p></p>
      <p>
      V bazi se nahajajo samo veljavni certifikati za ekološke proizvode in proizvode iz obdobja preusmeritve, ki so jih izdale tri zgoraj omenjene slovenske organizacije za kontrolo in certificiranje. V bazi ni mogoče najti certifikatov, ki so jih za ekološke proizvode in za proizvode iz preusmeritve izdale organizacije za kontrolo in certificiranje iz drugih držav članic EU in iz tretjih držav.
      </p>
      <p>
      V primeru, da iskalnik ne najde ničesar, nas lahko pokličete na 01 478 9068 v času uradnih ur Ministrstva za kmetijstvo, gozdarstvo in prehrano.
      </p>
      <p>
      Več o ekološkem kmetovanju lahko najdete <a href="http://www.mkgp.gov.si/si/delovna_podrocja/kmetijstvo/ekolosko_kmetovanje/">tukaj</a>.
      </p>
    </div>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'home',
  computed: {
        ...mapState('alert', ['status'])

    },
    data () {
        return {
          isci:'',
        }
      },
  created () {
       
       // this.success("test");
    },
      methods: {
        ...mapActions({clearAlert: 'alert/clear'}),
        ...mapActions({errorAlert: 'alert/error'}),
       
        handleSubmit(e){

          e.preventDefault();
        },
        isciCertifikat(e){
          this.clearAlert();
          if(!this.isci) {
              this.errorAlert("Vnesti morate iskalni niz!")
              return;
              }
          if(this.isci.length<3) {
              this.errorAlert("Iskalni niz mora biti dolg vsaj 3 znake")
              return;
              }
          
           this.$router.push({ name: 'certifikatiJavno', params: { isci: this.isci } })
        

        }
    }
}


</script>

<style>
h1{
  color:white;
}
#isci {
  max-width:500px
}
</style>